import { useEffect } from 'react';

/**
 * Custom hook to handle ESC key press for closing modals
 * @param {Function} onClose - Function to call when ESC key is pressed
 * @param {boolean} isEnabled - Whether the ESC key listener should be active
 */
const useEscKey = (onClose, isEnabled = true) => {
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape' && isEnabled) {
        onClose();
      }
    };

    if (isEnabled) {
      document.addEventListener('keydown', handleEscKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [onClose, isEnabled]);
};

export default useEscKey; 